import { EMOJI_KEY } from '@techchange/pm-specs';
import { Plugin, PluginKey } from 'prosemirror-state';

// import { getEmojiDataFromNative } from '../../../../../../_shared';

import EmojiView from '../nodeView';

export const emojiViewPluginKey = new PluginKey('emojiViewPlugin');

/**
 * Plugin that manages the emoji view.
 *
 * @param {string} emojiSize The style string for the width and height of the emoji.
 *
 * @returns {Object} Prosemirror Plugin object.
 */
const emojiViewPlugin = (emojiSize) =>

	new Plugin({

		key: emojiViewPluginKey,

		props: {

			nodeViews: {

				[EMOJI_KEY]: (node, view) => new EmojiView(node, view, emojiSize),

			},

			// TODO: Need to actually test this on a mobile device, but should
			// work in theory
			/* async handleTextInput(view, from, to, text) {

				const { tr, schema } = view.state;

				// Check for native emoji input and convert to a PM emoji node
				// const emoji = await getEmojiDataFromNative(text);
				const emoji = null;

				if (emoji) {

					const emojiNodeType = schema.nodes[EMOJI_KEY];
					const emojiNode = emojiNodeType.create(emoji);

					tr.replaceWith(from, to, emojiNode);
					view.dispatch(tr);

					return true;

				}

				return false;

			},*/

			// TODO: Figure out more efficient method of parsing native emojis from pasted text
			/*
			handlePaste(view, event, slice) {

				const { tr, schema } = view.state;

				const fragment = slice.content;

				// Keep track of updated child nodes of the fragment
				let updatedNodes = [];

				if (fragment) {

					// Find and replace native emoji characters with PM emoji nodes
					for (let i = 0; i < fragment.childCount; i++) {

						const childNode = fragment.child(i);

						const updatedChildNode = await findAndReplaceEmojis(childNode, schema);

						updatedNodes = updatedNodes.concat(updatedChildNode);

					}

					const newFragment = Fragment.fromArray(updatedNodes);
					const newSlice = new Slice(newFragment, slice.openStart, slice.openEnd);

					tr.replaceSelection(newSlice);
					view.dispatch(tr);

					// Prevent default
					return true;

				}

				return false;

			},
			*/

		},

	});

export default emojiViewPlugin;
